import React, { forwardRef, useEffect, useState } from 'react';

import { cn } from '@utils/tailwind/cn';

import { InputField } from './InputField';

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  id: string;
  initData: number;
  setData: React.Dispatch<
    React.SetStateAction<{
      [name: string]: number;
    }>
  >;
}

const TableInputField = forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, id, setData, initData, ...props }, ref) => {
    const [value, setValue] = useState<number>(initData ?? 0);
    return (
      <InputField
        {...props}
        ref={ref}
        value={value}
        className={cn('', className)}
        onChange={(e) => {
          if (!isNaN(Number(e.target.value))) {
            setValue(Number(e.target.value));
            setData((values: any) => ({
              ...values,
              [id]: e.target.value,
            }));
          }
        }}
      />
    );
  },
);
TableInputField.displayName = 'TableInput';

export { TableInputField };
